// This file is automatically generated by copy-versions.ts script

export const application = {version: '1.2.0', revision: '', branch: ''};
export const dependencies = {nx: '', cli: '', core: '', mat: '', rxjs: '', svgjs: '', ts: '', webpack: ''};
export const date = '2025-06-12T11:27:17.655Z';
